/**
 * Remove unwanted characters
 */
export function removeSymbolsExceptExtension(str) {
    return str.replace(/[^a-zA-Z0-9._/-]/g, "");
}

/**
 * Convert filename into safe S3 naming format
 */
export function convertToS3NamingFormat(str, mimeType, req = false) {
  const mimeParts = mimeType.split("/");
  const fileExtension = mimeParts.pop()?.toLowerCase() || "";

  const baseName = str
    .trim()
    .replace(/\s+/g, "-")
    .replace(/\.+/g, "-");

  const cleaned = removeSymbolsExceptExtension(baseName).replace(/-+/g, "-");

  const fileName = `${cleaned}.${fileExtension}`;

  if (!req) return fileName;

  const now = new Date();

  const date = now.toISOString().split("T")[0];
  const time = now
    .toTimeString()
    .split(" ")[0]
    .replace(/:/g, "-");

  return `requirment-${date}-${time}-${fileName}`;
}

/**
 * Presigned URL cache
 */
const presignCache = {};

/**
 * Fetch a presigned POST URL (or return cached)
 */
async function getPresignedUrl(bucketName, objectName, contentType, expiration = 3600) {
    const cacheKey = `${bucketName}/${objectName}`;
    const now = Date.now();

    if (presignCache[cacheKey] && now < presignCache[cacheKey].expiresAt) {
        return presignCache[cacheKey];
    }

    const res = await fetch(process.env.REACT_APP_AWS_LAMBDA_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
        fileName: objectName,
        fileType: contentType,
        bucket_name: bucketName,
        object_name: objectName,
        expiration,
        fields: {
            acl: "public-read",
            "Content-Type": contentType,
        },
        conditions: [
            ["eq", "$Content-Type", contentType],
            ["content-length-range", 0, 10485760], // 10MB
        ],

        uploadFileName: objectName,
        uploadFileType: contentType,
        }),
    });

    if (!res.ok) throw new Error("Failed to get presigned URL");

    const data = await res.json();

    presignCache[cacheKey] = {
        ...data,
        expiresAt: now + expiration * 1000 - 10_000,
    };

    return presignCache[cacheKey];
}

export async function uploadFileToS3({ file, bucketName="csappproduction-storage", contentType, req=false }) {
    if (!file) throw new Error("No file provided");

    const objectName = convertToS3NamingFormat(file.name, contentType, req);
    console.log(objectName);
    
    const presigned = await getPresignedUrl(bucketName, objectName, contentType);
    console.log(presigned);

    const formData = new FormData();
    Object.entries(presigned.fields).forEach(([key, value]) =>
        formData.append(key, value)
    );

    formData.append("file", file);

    const uploadRes = await fetch(presigned.url, {
        method: "POST",
        body: formData,
    });

    if (!uploadRes.ok) {
        const errText = await uploadRes.text();
        throw new Error(`S3 upload failed: ${errText}`);
    }

    // Return S3 object path or full URL depending on your needs
    return {
        objectName,
        url: `${presigned.url}${objectName}`,
    };
}
